import a1 from "./article1.md";
import i1 from "../assets/w1.jpg";

import a2 from "./article2.md";
import i2 from "../assets/w2.jpg";

import i3 from "../assets/w3.jpg";
import i4 from "../assets/w4.jpg";
import i5 from "../assets/w5.jpg";
import i6 from "../assets/w6.jpg";
export const blog = [
  {
    title: "Seasonal Landscaping: Transforming Your Outdoor Space Year-Round",
    tag: "gardens",
    intro:
      "The beauty of nature is in its ever-changing allure, and your outdoor space should be no different. With each passing season, your landscape has the opportunity to don a new, captivating identity. Seasonal landscaping is the art of adapting your outdoor space to the shifting elements, ensuring that it remains a source of beauty, inspiration, and functionality throughout the year.",
    article: a1,
    img: i1,
    date: "August 1, 2023",
  },
  {
    title: "Cultivating Beauty with Eco-Friendly Practices",
    tag: "tips",
    intro:
      "Gardens have a remarkable power to enrich our lives, offering a haven of tranquility and a connection to the natural world. But what if your garden could do even more? By embracing sustainable practices, you can create a garden that not only delights the senses but also supports the environment. Join us as we explore the art of cultivating a sustainable garden that harmonizes beauty and ecological responsibility.",
    article: a2,
    img: i2,
    date: "August 2, 2023",
  },
  {
    title: "Maximizing Small Spaces: Creating Your Urban Oasis",
    tag: "urban",
    intro:
      "Living in a bustling city doesn't mean you have to sacrifice greenery and serenity. Discover the art of transforming limited urban spaces into vibrant and lush oases. From vertical gardens to clever space-saving techniques, learn how to create your own urban paradise.",
    article: a1,
    img: i3,
    date: "August 4, 2023",
  },
  {
    title: "The Zen of Minimalist Landscaping: Embracing Simplicity",
    tag: "design",
    intro:
      "Less can truly be more when it comes to landscaping. Explore the principles of minimalist design that emphasize clean lines, open spaces, and a sense of tranquility. Learn how to curate a garden that evokes calmness and elegance through simplicity.",
    article: a1,
    img: i4,
    date: "August 5, 2023",
  },
  {
    title: "Edible Landscapes: Growing Your Own Garden of Delights",
    tag: "gardens",
    intro:
      "Unleash your inner gardener and chef by creating an edible landscape. Discover the joys of growing your own fruits, vegetables, and herbs in harmony with ornamental plants. From raised beds to companion planting, embark on a journey of cultivating a garden that's both beautiful and bountiful.",
    article: a1,
    img: i5,
    date: "August 6, 2023",
  },
  {
    title: "Wildlife-Friendly Backyards: Inviting Nature to Your Doorstep",
    tag: "wildlife",
    intro:
      "Transform your backyard into a haven for wildlife by providing essential habitats and resources. From birdhouses to pollinator-friendly flowers, learn how to attract a diverse array of creatures and create a thriving ecosystem right outside your door.",
    article: a1,
    img: i6,
    date: "August 7, 2023",
  },
];
